module.exports = __webpack_public_path__ + "6a6b95a38be24bc7f0568161d0a37a36.gif";